import { CheckRounded, CreditCardRounded, QrCodeScannerRounded } from "@mui/icons-material"
import { Divider } from "@mui/material"

import payload from '@app/payload';
import { useState } from "react";
import { isStripeProvider } from '@utils/provider';
import Text from '@components/Text';
import { t } from '@i18n';

import './styles.scss';

export default function MethodSelect({ initial, valuesRef, refreshHandler, provider }) {
    const [current, setCurrent] = useState(initial)

    if (isStripeProvider(provider)) {
        return null;
    }

    const config = payload.plans.find(p => p.id === valuesRef.current.plan).methods

    const methods = {
        credit: {
            title: t('method.creditCard'),
            icon: <CreditCardRounded />
        },

        pix: {
            title: t('method.pix'),
            icon: <QrCodeScannerRounded />
        }
    }

    function onChange(method) {
        setCurrent(method)
        valuesRef.current.method = method
        refreshHandler()
    }

    const isMethodAllowed = (method) => config[method]?.enabled
    const onlyCreditEnabled = config?.credit?.enabled && !config?.pix?.enabled

    function MethodBox({ method }) {
        const { icon, title } = methods[method]
        const selected = method === current

        return (
            <div onClick={() => onChange(method)} className={"method-box " + (selected && 'method-selected')}>
                <div className="method-icon-box">
                    {icon}
                    <div className="select-method-btn">
                        {
                            selected
                                ? <CheckRounded sx={{ fontSize: 14 }} className="method-check-icon" />
                                : null
                        }
                    </div>
                </div>
                <Divider flexItem />
                <Text.small className={"method-title "}>{title}</Text.small>
            </div>
        )
    }

    if (onlyCreditEnabled) return null

    return (
        <>
            <div className="methods-available">
                {
                    Object.keys(methods).map((method, i) => <>
                        {isMethodAllowed(method) && <MethodBox
                            method={method}
                            key={i}
                        />}
                    </>)
                }
            </div>
        </>
    )
}
